import { fmtNum } from "../lib/format";

export const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-slate-700 bg-[#0B0F19]/95 backdrop-blur-md px-3 py-2 shadow-xl">
      <p className="font-mono text-xs text-slate-400 mb-1.5">{label}</p>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center gap-2 text-xs py-0.5">
          <span className="h-2 w-2 rounded-full" style={{ background: p.color }} />
          <span className="text-slate-300 max-w-[160px] truncate">{p.name}</span>
          <span className="ml-auto pl-4 font-mono text-slate-100">{fmtNum(p.value)}</span>
        </div>
      ))}
    </div>
  );
};
